import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { UiActionExpanderModule } from '@components/ui-action-expander';
import { UiPasswordIndicatorModule } from '@components/ui-password-indicator/ui-password-indicator.module';
import { UiPasswordTypeToggleModule } from '@components/ui-password-toggle/ui-password-toggle.module';
import { UserPermissionModule } from '@components/ui-user-permissions/user-permissions.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { AdSearchModule } from '@pages/users/components/ad-search/ad-search.module';
import { ProvisionRobotModule } from '@pages/users/components/provision-robot/provision-robot.module';
import {
    UserGroupImportModalComponent,
    UserModalComponent,
} from '@pages/users/modals';
import { CheckPermissionsModalComponent } from '@pages/users/modals/check-permissions';
import { UsersPageComponent } from '@pages/users/users.page';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

const MODALS = [
    UserModalComponent,
    UserGroupImportModalComponent,
    CheckPermissionsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UiSuggestModule,
        SharedModule,
        UiContentLoaderModule,
        UiPasswordTypeToggleModule,
        UiPasswordIndicatorModule,
        UiGridModule,
        UiGridResetModule,
        UiActionExpanderModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiDateFormatModule,
        UiSpinnerButtonModule,
        ProvisionRobotModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        UserPermissionModule,
        AdSearchModule,
    ],
    declarations: [
        UsersPageComponent,
        ...MODALS,
    ],
    exports: [
        UsersPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class UserModule { }
